import { PortalModule } from "@/@core";

export const module = {
  name: "tarif-covid",
  routes: [
    {
      path: `/`,
      component: () => import("./views/home/Index.vue"),
    },
    {
      path: `/input-files`,
      component: () => import("./views/input-files/Index.vue"),
      auth: { roles: ["DOCUMENT_ADMIN"] },
    },
    {
      path: `/payment-files`,
      component: () => import("./views/payment-files/Index.vue"),
      auth: { roles: ["PAYER"] },
    },
    {
      path: `/payments/list`,
      component: () => import("./views/payment-list/Index.vue"),
      auth: { roles: ["SUPPORT"] },
    },
    {
      path: `/payments/details`,
      component: () => import("./views/payment-details/Index.vue"),
      auth: { roles: ["SUPPORT", "CITIZEN"] },
    },
    {
      path: `/admin/send`,
      component: () => import("./views/admin-send/Index.vue"),
      auth: { roles: ["DOCUMENT_ADMIN"] },
    },
  ],
  supportedLocales: ["fr", "nl"],
} as PortalModule;
